import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import AddOnRow from './row';
import Button from '../../button';
import LoadingSpinner from '../../loading';
import WhitePlusSign from '../../../assets/add-ons/white_plus.svg';
import { locale } from './locale';
import styles from './styles-module.css';
import { CREATE_ADDON_URL, SHOW_ALL } from '../consts';

const DesktopAddOnsTable = injectIntl((props) => {
  const {
    intl,
    loading,
    hasPermissionForManageAddOns,
    renderNoAddOnFound,
    selectedStatus,
    listings,
    history,
    renderAddOnStatusFilter,
    renderAddOnsSearch,
    addOnSearch,
    setSearchedEventList,
    searchEventKey,
    renderAddonsFilterByEvent,
  } = props;
  let content;
  let tableHeader;

  useEffect(() => {
    setSearchedEventList(listings);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listings])

  const isFilterApplied = addOnSearch?.length > 0 || searchEventKey?.length > 0 || selectedStatus !== SHOW_ALL;
  const showTableHeader = props.addOns?.length > 0;

  const drawTable = () => {
    const addOns = Object.assign([], props.addOns);
    if (addOns.length) {
      return addOns.map((addOn, index) => {
        return <AddOnRow
           key={addOn.id}
           addOn={addOn}
           handleOnAddOnsStatusChange={props.handleOnAddOnsStatusChange}
           handleOnAddOnsDelete={props.handleOnAddOnsDelete}
           index={index}
           intl={intl}
           rate={addOn.rates}
           hasPermissionForManageAddOns={hasPermissionForManageAddOns}
           history={history}
         />
      });
    }

    return renderNoAddOnFound(isFilterApplied);
  }

  const displayCreateButton = () => {
      return (
        <Link to={CREATE_ADDON_URL}>
          <Button className={`blue ${styles.createAddOnBtn}`}>
            <WhitePlusSign />
            <span>{intl.formatMessage(locale.createAddOn)}</span>
          </Button>
        </Link>
      );
  }

  if (loading) {
    content = (
      <div className={styles.row}>
        <LoadingSpinner className={styles.loadingSpinner} />
      </div>
    );
  }
  else {
    if (showTableHeader) {
      tableHeader = (
        <div className={styles.addOnsTableHeader}>
          <div className={`${styles.column} ${styles.status}`}>{intl.formatMessage(locale.active)}</div>
          <div className={`${styles.column} ${styles.addOn}`}>{intl.formatMessage(locale.addOnName)}</div>
          <div className={`${styles.column} ${styles.options}`}>{intl.formatMessage(locale.options)}</div>
          <div className={`${styles.column} ${styles.price}`}>{intl.formatMessage(locale.price)}</div>
          <div className={`${styles.column} ${styles.available}`}>{intl.formatMessage(locale.available)}</div>
          <div className={`${styles.column} ${styles.appliesTo}`}>{intl.formatMessage(locale.appliesTo)}</div>
          <div className={`${styles.column} ${styles.actions}`}>{intl.formatMessage(locale.actions)}</div>
        </div>
      );
    }
    content = drawTable();
  }

  return (
    <div>
      <div className={styles.filterAndCreateRow}>
        {renderAddOnStatusFilter(true)}
        {renderAddOnsSearch(true)}
        {renderAddonsFilterByEvent(true)}
        {hasPermissionForManageAddOns && displayCreateButton()}
      </div>
      {tableHeader}
      {content} 
    </div>
  );
});

export default DesktopAddOnsTable;
